"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loading = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Loading = require("./Loading.styles");

var _iconLoading = _interopRequireDefault(require("../../svg/icon-loading"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Loading = ({
  className,
  show,
  size,
  strokeWidth,
  strokeColor,
  ...restProps
}) => {
  return show ? /*#__PURE__*/_react.default.createElement(_Loading.StyledLoading, _extends({
    className: className
  }, restProps), /*#__PURE__*/_react.default.createElement(_iconLoading.default, {
    size: size,
    strokeWidth: strokeWidth,
    strokeColor: strokeColor
  })) : null;
};

exports.Loading = Loading;
Loading.defaultProps = {
  size: 44,
  show: true
};
Loading.propTypes = {
  show: _propTypes.default.bool,
  className: _propTypes.default.string,
  size: _propTypes.default.number,
  strokeWidth: _propTypes.default.number,
  strokeColor: _propTypes.default.string
};